import { createLazyOverlay } from "./createLazyOverlay";
import type { ComponentProps } from "react";
import type { SheetPanel as SheetPanelComponent } from "./SheetPanel";
export const Sheet = createLazyOverlay<ComponentProps<typeof SheetPanelComponent>>({
  name: "sheet",
  load: () => import("./SheetPanel"),
  exportName: "SheetPanel",
  renderFallback: () => null
});